import styles from './datascient-ui-library.module.css';

/* eslint-disable-next-line */
export interface DatascientUiLibraryProps {}

export function DatascientUiLibrary(props: DatascientUiLibraryProps) {
  return (
    <div className={styles['container']}>
      <h1>Welcome to DatascientUiLibrary!</h1>
    </div>
  );
}

export default DatascientUiLibrary;
